export default Boolean(self.indexedDB);
